import React, { ReactNode } from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './ResultTitle.module.scss';
import SuccessImage from '../../../../../../assets/images/vectors/success-rounded.svg';
import ErrorImage from '../../../../../../assets/images/vectors/error-rounded.svg';

type ResultTitleProps = {
  isSuccessful: boolean;
  title: ReactNode;
  description?: ReactNode;
};

const ResultTitle = ({ isSuccessful, title, description }: ResultTitleProps) => {
  const image = isSuccessful ? (
    <img className={classes.image} src={SuccessImage} alt="success" />
  ) : (
    <img className={classes.image} src={ErrorImage} alt="error" />
  );

  return (
    <div className={classes.container}>
      {image}
      <TitleWithDescription
        title={title}
        description={description}
        titleFont="title-18-bold"
      />
    </div>
  );
};

export { ResultTitle };
